import TagPlugin from "@aspectus/vue-tag";
import GridPlugin from "@aspectus/vue-grid";

export default function Elements(Vue) {
  Vue.use(TagPlugin);
  Vue.use(GridPlugin);
}
